import { ref } from 'vue';

export interface Toast {
  id: string,
  message: string,
  actionLabel?: string,
  onAction?: () => void | Promise<void>,
  onClose?: ({ reason }: { reason: 'timeout' | 'dismiss' | 'action' }) => void | Promise<void>,
  duration?: number,
}

const toasts = ref<Toast[]>([]);

const addToast = ({ ...toast }: { message: Toast['message'], actionLabel?: Toast['actionLabel'], onAction?: Toast['onAction'], onClose?: Toast['onClose'], duration?: Toast['duration'] }) => {
  const id = Math.random().toString(36).substring(2, 9);
  const newToast = { ...toast, id };

  toasts.value.push(newToast);

  if (toast.duration !== 0) {
    setTimeout(() => {
      removeToast({ id, reason: 'timeout' });
    }, toast.duration || 20000);
  }

  return id;
};

const removeToast = ({ id, reason = 'dismiss' }: { id: string, reason?: 'timeout' | 'dismiss' | 'action' }) => {
  const toast = toasts.value.find(t => t.id === id);
  if (toast?.onClose) {
    toast.onClose({ reason });
  }
  toasts.value = toasts.value.filter(t => t.id !== id);
};

const toastStore = {
  toasts,
  addToast,
  removeToast,
};

export function useToast() {
  return toastStore;
}

// Export internal state and logic used only for testing here. Do not reference these in production logic.
// ESLint-required for TypeScript modules.
export const TEST_ONLY = {
  toastStore,
};
